// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"627":"51cd7ab2117ccdd1","5733":"7903566320a4a7ee"}[chunkId] + ".js";
};